import React, { useCallback, useMemo, useState } from 'react'
import { Row, Col, Typography, Input, Collapse, Tooltip, Alert } from 'antd'
import _ from 'lodash';
import { CaretDownOutlined } from '@ant-design/icons';
import { SearchIcon } from "components/Icons";
import PerfectScrollbar from 'react-perfect-scrollbar'
import Vocabulary, { getVocabulary } from 'components/Vocabulary';
import { BASE_GUTTER, DRAWER_SIZE_DEFAULT, MODAL_SIZE_EXTRA_SMALL } from "constants/Layout";

const ProductAndSubProductList = ({ listing }) => {
    const [searchText, setSearchText] = useState('');

    const onSearch = useCallback(e => setSearchText(e.target.value || ""), []);

    const filteredData = useMemo(() => {
        const text = (searchText || '').trim().toLowerCase();
        if (!text) {
            return listing;
        }
        return listing.filter(list => {
            return list.product.name.toLowerCase().includes(text);
        })
    }, [searchText, listing])

    return (

        <div style={{ width: DRAWER_SIZE_DEFAULT }} onClick={e => e.stopPropagation()}>
            <Row gutter={BASE_GUTTER}>
                <Col span={24}>
                    <Typography.Text className='m-x-m'><Vocabulary name="product" isPlural={true} />/<Vocabulary name="subProduct" isPlural={true} /></Typography.Text>
                </Col>
                <Col span={18}>
                    <Input autoFocus className="data-list-search m-x-m" suffix={<SearchIcon />} onChange={onSearch}  allowClear placeholder={`Search ${getVocabulary("product")}(s)`} />
                </Col>
                <Col span={24}>
                    <div style={{ height: MODAL_SIZE_EXTRA_SMALL }}>
                        <PerfectScrollbar>
                            <ProductSubProductList products={filteredData} />
                        </PerfectScrollbar>
                    </div>
                </Col>
            </Row>
        </div>

    )
}

export default ProductAndSubProductList;


const ProductSubProductList = ({ products, ...restProps }) => {
    if (_.isEmpty(products)) {
        return <Alert type="info" description={<><Typography.Text strong>Note: </Typography.Text> <Typography.Text>No <Vocabulary name="product" isPlural={true} /> has been found.</Typography.Text></>} />;
    }
    return (
        <Collapse className="pro-subPro-list" bordered={false} expandIconPosition="left"
            expandIcon={({ isActive }) => <Tooltip placement="topLeft" title={`Click to ${isActive ? "Collapse" : "Expand"}`}><CaretDownOutlined rotate={isActive ? 0 : -90} style={{ fontSize: 16 }}/></Tooltip>}
        >
            {products.map(product => <ProductDetail key={product.id} productData={product} {...restProps} />)}
        </Collapse>
    )
}

const ProductDetail = ({ productData, ...restProps }) => {

    return (
        <Collapse.Panel {...restProps}
            key={productData.product.name}
            header={<>
                <div>
                    <Typography.Text className='m-r-xs' ellipsis style={{ maxWidth: 400 }} title={productData.product.name}>{productData.product.name}{` `}</Typography.Text>
                    <Typography.Text>{!_.isEmpty(productData.subProducts) ? `(${productData.subProducts.length})` : null}</Typography.Text>
                </div>
            </>
            }
        >
            <Row className='m-0' justify="start" align='middle' gutter={BASE_GUTTER}>
                {_.isEmpty(productData.subProducts) && <Col span={24}>No <Vocabulary name="subProduct" isPlural={true} /></Col>}
                {
                    productData.subProducts.map(subProduct => {
                        return (
                            <Col span={8} key={subProduct.id}>
                                <div title={subProduct.name} className='text-ellipsis m-l-m'>{subProduct.name}</div>
                            </Col>
                        )
                    })
                }
            </Row>
        </Collapse.Panel>
    )
}